import { useEffect } from 'react';

import { appEvents } from '@/services/events';
import { StorageKeys } from '@/services/storage';

export const useLogoutListener = (): void => {
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent): void => {
      if (event.key === StorageKeys.GxToken && !event.newValue) {
        appEvents.emit('user:logout', { reason: 'manual' });
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};
